import { RuleProps } from 'types/application';

export const LICENCE_TYPE = 'licence-type';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const OPERATING_ADDRESS_INFORMATION = 'operating-address-information-exhibition';
export const OPERATING_ADDRESS_INFORMATION_TEMPORARY = 'operating-address-information-exhibition-temporary';
export const DETAILS_OF_FILM_EXHIBITION_PLAN = 'details-of-film-exhibition-plan';
export const AGE_CHECK_MECHANISM = 'age-check-mechanism';
export const FDEL_ADDITIONAL = 'fdel-additional';

export const FDEL_APPLICATION = [
    {
        sectionID: LICENCE_TYPE,
        sectionName: 'Licence Type',
        fieldList: [
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            },
            {
                id: 'start-date',
                label: 'Start Date',
                type: 'text'
            },
            {
                id: 'expiry-date',
                label: 'Expiry Date',
                type: 'text'
            },
            {
                id: 'media-type',
                label: 'Media Type',
                type: 'text'
            },
            {
                id: 'type-of-filmvideo',
                label: 'Type of Film/Video',
                type: 'text'
            },
            {
                id: 'other-please-specify',
                label: 'If others, please specify',
                type: 'text',
                rule: {
                    baseIds: [`${LICENCE_TYPE}-other-please-specify`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const value = baseValues?.[`${LICENCE_TYPE}-other-please-specify`];
                        return value === '' || value === '-';
                    }
                }
            }
        ]
    },
    {
        sectionID: OPERATING_ADDRESS_INFORMATION,
        sectionName: 'Operating Address Information',
        rule: {
            baseIds: [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-purpose-objective`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues && baseValues[`${LICENCE_TYPE}-licence-category`] === 'Temporary Exhibition - Up to 30 days'
                );
                return result;
            }
        },
        fieldList: [
            {
                id: 'operating-address-information-exhibition-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'operating-address-information-exhibition-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'no',
                                header: 'No.',
                                type: 'text'
                            },
                            {
                                id: 'trading-name',
                                header: 'Trading Name',
                                type: 'text'
                            },
                            {
                                id: 'number-of-halls-or-rooms',
                                header: 'Number of Halls/Rooms',
                                type: 'text'
                            },
                            {
                                id: 'duplicated',
                                header: 'Duplicated',
                                type: 'text'
                            },
                            {
                                id: 'rating',
                                header: 'Rating',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'operating-address-information-exhibition-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'videos-are-stored-at-this-place',
                                label: 'Videos are Stored at this Place',
                                type: 'text'
                            },
                            {
                                id: 'sharing-of-premise',
                                label: 'Sharing of Premise',
                                type: 'text'
                            },
                            {
                                id: 'premise-type',
                                label: 'Premise Type',
                                type: 'text'
                            },
                            {
                                id: 'address-format',
                                label: 'Address Format',
                                type: 'text'
                            },
                            {
                                id: 'postal-code',
                                label: 'Postal Code',
                                type: 'text'
                            },
                            {
                                id: 'building-name',
                                label: 'Building Name',
                                type: 'text'
                            },
                            {
                                id: 'blk-house-no',
                                label: 'Block/House No.',
                                type: 'text'
                            },
                            {
                                id: 'street-name',
                                label: 'Street Name',
                                type: 'text'
                            },
                            {
                                id: 'floor-level',
                                label: 'Floor/Level',
                                type: 'text'
                            },
                            {
                                id: 'unit',
                                label: 'Unit',
                                type: 'text'
                            },
                            {
                                id: 'address-line-one',
                                label: 'Address Line 1',
                                type: 'text'
                            },
                            {
                                id: 'address-line-two',
                                label: 'Address Line 2',
                                type: 'text'
                            },
                            {
                                id: 'address-line-three',
                                label: 'Address Line 3',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: OPERATING_ADDRESS_INFORMATION_TEMPORARY,
        sectionName: 'Operating Address Information (Temporary Exhibition)',
        rule: {
            baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
            hidden: ({ baseValues }: RuleProps) => {
                if (Boolean(baseValues && baseValues[`${LICENCE_TYPE}-licence-category`] === 'Temporary Exhibition - Up to 30 days')) {
                    return false;
                }
                return true;
            }
        },
        fieldList: [
            {
                id: 'name-of-event',
                label: 'Name of Event',
                type: 'text'
            },
            {
                id: 'number-of-halls-rooms',
                label: 'Number of Halls/Rooms',
                type: 'text'
            },
            {
                id: 'address-format',
                label: 'Address Format',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'blk-house-no',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'floor-level',
                label: 'Floor/Level',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return false;
                        }
                        return true;
                    }
                }
            },
            {
                id: 'address-line-one',
                label: 'Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return true;
                        }
                        return false;
                    }
                }
            },
            {
                id: 'address-line-two',
                label: 'Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return true;
                        }
                        return false;
                    }
                }
            },
            {
                id: 'address-line-three',
                label: 'Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-name-of-event`],
                    hidden: ({ baseValues }: RuleProps) => {
                        if (
                            Boolean(baseValues && baseValues[`${OPERATING_ADDRESS_INFORMATION_TEMPORARY}-address-format`] === 'Formatted')
                        ) {
                            return true;
                        }
                        return false;
                    }
                }
            }
        ]
    },
    {
        sectionID: DETAILS_OF_FILM_EXHIBITION_PLAN,
        sectionName: 'Details of Film Exhibition Plan',
        fieldList: [
            {
                id: 'purpose-objective',
                label: 'Purpose/Objective of Film Exhibition',
                type: 'text'
            },
            {
                id: 'target-audience',
                label: 'Target Audience',
                type: 'text'
            },
            {
                id: 'film-screening-venue',
                mainLabel: 'Film Screening Venue',
                label: "The screening at this venue's operating address as given above will be held",
                type: 'text',
                rule: {
                    baseIds: [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-film-screening-venue`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${DETAILS_OF_FILM_EXHIBITION_PLAN}-film-screening-venue`] === '-'
                }
            },
            {
                id: 'drive-in-screening',
                label: 'This is a drive-in screening',
                type: 'text',
                rule: {
                    baseIds: [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-drive-in-screening`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${DETAILS_OF_FILM_EXHIBITION_PLAN}-drive-in-screening`] === '-'
                }
            },
            {
                id: 'entry-to-the-screening',
                label: 'Entry to the screening is',
                type: 'text',
                rule: {
                    baseIds: [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-entry-to-the-screening`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${DETAILS_OF_FILM_EXHIBITION_PLAN}-entry-to-the-screening`] === '-'
                }
            },
            {
                id: 'if-more-than-one-entry',
                label: 'If more than 1 option is selected, please clarify briefly',
                type: 'text',
                rule: {
                    baseIds: [`${DETAILS_OF_FILM_EXHIBITION_PLAN}-if-more-than-one-entry`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${DETAILS_OF_FILM_EXHIBITION_PLAN}-if-more-than-one-entry`] === '-'
                }
            }
        ]
    },
    {
        sectionID: AGE_CHECK_MECHANISM,
        sectionName: 'Age-check Mechanisms',
        rule: {
            baseIds: [`${AGE_CHECK_MECHANISM}-security-id-checks`],
            hidden: ({ baseValues }: RuleProps) =>
                baseValues?.['licence-type-licence-category'] === 'Distribution (Restricted) Licence - 1 Year' ||
                baseValues?.['licence-type-licence-category'] === 'Distribution (Restricted) Licence - 3 Year'
        },
        fieldList: [
            {
                id: 'security-id-checks',
                label: 'Security ID checks for min. age at all entry points to the screening area',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-security-id-checks`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-security-id-checks`] === '-'
                }
            },
            {
                id: 'venue-is-enclosed-for-screening',
                label: 'Venue is enclosed for screening of age-restricted films',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-venue-is-enclosed-for-screening`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-venue-is-enclosed-for-screening`] === '-'
                }
            },
            {
                id: 'venue-are-enclosed-for-screening',
                label: 'Venue(s) are enclosed for screening of age-restricted films',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-venue-are-enclosed-for-screening`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-venue-are-enclosed-for-screening`] === '-'
                }
            },
            {
                id: 'film-rating-signage',
                label: 'Film rating signages are at Point of Sale and Entrances',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-film-rating-signage`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-film-rating-signage`] === '-'
                }
            },
            {
                id: 'film-ratings-and-consumer',
                label: 'Film ratings and consumer advisory are on all publicity materials',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-film-ratings-and-consumer`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-film-ratings-and-consumer`] === '-'
                }
            },
            {
                id: 'restricted-film-ratings-and-consumer',
                label: 'Film ratings and consumer advisories are on publicity materials',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-restricted-film-ratings-and-consumer`],
                    hidden: ({ baseValues }: RuleProps) =>
                        baseValues?.[`${AGE_CHECK_MECHANISM}-restricted-film-ratings-and-consumer`] === '-'
                }
            },
            {
                id: 'all-films-for-screening-in-schedule',
                label: 'All films for screening in the Schedule are IMDA-classified',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-all-films-for-screening-in-schedule`],
                    hidden: ({ baseValues }: RuleProps) =>
                        baseValues?.[`${AGE_CHECK_MECHANISM}-all-films-for-screening-in-schedule`] === '-'
                }
            }
        ]
    },
    {
        sectionID: AGE_CHECK_MECHANISM,
        sectionName: 'Age-check Mechanisms',
        rule: {
            baseIds: [`${AGE_CHECK_MECHANISM}-security-id-checks`],
            hidden: ({ baseValues }: RuleProps) =>
                baseValues?.['licence-type-licence-category'] === 'Exhibition (Restricted) Licence - 1 Year' ||
                baseValues?.['licence-type-licence-category'] === 'Exhibition (Restricted) Licence - 3 Year' ||
                baseValues?.['licence-type-licence-category'] === 'Temporary Exhibition - Up to 30 days'
        },
        fieldList: [
            {
                id: 'publicity-materials',
                label: 'IMDA films ratings are on publicity materials',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-publicity-materials`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-publicity-materials`] === '-'
                }
            },
            {
                id: 'consumer-advice',
                label: 'IMDA film rating and advice are on films/videos',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-consumer-advice`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-consumer-advice`] === '-'
                }
            },
            {
                id: 'r21-films-videos',
                label: 'No distribution of R21 Films/videos',
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-r21-films-videos`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-r21-films-videos`] === '-'
                }
            },
            {
                id: 'id-checks-patrons',
                label: "ID Checks for patrons' min. age at point of sale",
                type: 'text',
                rule: {
                    baseIds: [`${AGE_CHECK_MECHANISM}-id-checks-patrons`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${AGE_CHECK_MECHANISM}-id-checks-patrons`] === '-'
                }
            }
        ]
    },
    {
        sectionID: FDEL_ADDITIONAL,
        sectionName: '',
        rule: {
            baseIds: [`${FDEL_ADDITIONAL}-technical-requirements`],
            hidden: ({ baseValues }: RuleProps) => baseValues?.['licence-type-licence-category'] !== 'Temporary Exhibition - Up to 30 days'
        },
        fieldList: [
            {
                id: 'technical-requirements',
                label: 'Technical Requirements',
                type: 'text',
                rule: {
                    baseIds: [`${FDEL_ADDITIONAL}-technical-requirements`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${FDEL_ADDITIONAL}-technical-requirements`] === '-'
                }
            },
            {
                id: 'intend-to-use-local-equipment',
                label: 'Intend to use local broadcast transmission equipment',
                type: 'text',
                rule: {
                    baseIds: [`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${FDEL_ADDITIONAL}-intend-to-use-local-equipment`] === '-'
                }
            },
            {
                id: 'intend-to-use-local-signals',
                label: 'Intend to use local equipment to receive local broadcast signals',
                type: 'text',
                rule: {
                    baseIds: [`${FDEL_ADDITIONAL}-intend-to-use-local-signals`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${FDEL_ADDITIONAL}-intend-to-use-local-signals`] === '-'
                }
            },
            {
                id: 'will-need-frequencies',
                label: 'Will need to use radio frequencies',
                type: 'text',
                rule: {
                    baseIds: [`${FDEL_ADDITIONAL}-will-need-frequencies`],
                    hidden: ({ baseValues }: RuleProps) => baseValues?.[`${FDEL_ADDITIONAL}-will-need-frequencies`] === '-'
                }
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
